import _http_v1 from '@packs/http_requests/_http_v1'
import List from './list/list'
import store from '../../../../store'
import Button from './button/button'

export default function PluStationsComponent(opts = {}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let chart_name = opts.chart_name
    let context = this
    let button_add_plus
    let listComponent
    

    this.generate = () =>{
        createContainers()
        this.generateButton()
        this.generateSuggestedStations()

        $(container).append(elements.button_add_plus,elements.stations_list_container)

        store.subscribe('chart_nested_prop_update', data=>{
            if(data.chart_name == chart_name && (data.prop_path == 'stations_list.flu.ids' || data.prop_path == 'series.rain.options.show')){
                //Limpando lista plu
                store.setChartNestedProp(chart_name, 'stations_list.plu.ids', [])

                this.updateSuggestedStations()
            }
        })
    }

    this.generateButton = _ =>{
        button_add_plus = new Button({container:elements.button_add_plus,chart_name:chart_name})
        button_add_plus.generate()

        button_add_plus.on('click', show=>{
            listComponent.show(show)
            store.setChartNestedProp(chart_name, 'series.rain.options.show', show)
        })
    }

    this.generateSuggestedStations = () =>{
        
        listComponent = new List({container:elements.stations_list_container, loading: true, chart_name:chart_name })
        listComponent.generate()

        this.updateSuggestedStations()
    }

    this.updateSuggestedStations = _ =>{

        //listComponent em estado de 'carregando'
        listComponent.update(true)

        let flu_ids = store.getChartNestedProp(chart_name, 'stations_list.flu.ids') || []
        flu_ids = flu_ids.map(Number)
        if(flu_ids.length > 0){
            //exibindo botão
            button_add_plus.show(true)
            if(showPluList()){
                getClosestStations(flu_ids).then(data=>{
                    listComponent.setList(data.json)
                })
            }
            
        } else {

            noFluState()
        
        }
        
    }

    const getClosestStations = async ids =>{
        return _http_v1.request('station_prefixes/closest', 'GET', {station_prefix_ids: ids, distance:10})
    }

    const createContainers = _ =>{
        elements.button_add_plus = context.createElement('div')
        elements.stations_list_container = context.createElement('div')
        $(elements.stations_list_container).css({
            'margin-top': '10px'
        })
    }

    const noFluState = () =>{
        //lista de postos flu vazia, algumas ações são tomadas no caso

        //escondendo lista
        listComponent.show(false)
            
        //escondendo botão
        button_add_plus.show(false)

        //definindo para 'falso' a opção de postos plus para o gráfico
        store.setChartNestedProp(chart_name, 'series.rain.options.show', false)
    }

    const showPluList = _ =>{
        let current = store.getChartNestedProp(chart_name, 'series.rain.options.show')
        return current === 'true' || current === true
    }

}

PluStationsComponent.prototype = Object.create(BaseConstructor.prototype)